import { render, staticRenderFns } from "./FormFixedFooter.vue?vue&type=template&id=5f6012ac"
import script from "./FormFixedFooter.vue?vue&type=script&lang=js"
export * from "./FormFixedFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports